import type { TFunction } from "i18next";
import { ExternalLink } from "lucide-react";
import { Trans } from "react-i18next";
import { toNumber } from "@/lib/paging";
import { vbsContactUrl } from "@/lib/vbs";

/**
 * The reasons a beheerder can be shown, in the order the banner groups them - most actionable
 * first. `Gevonden` is not among them: a row only reaches that list because something is missing.
 */
export const REDENEN = [
  "GeenPostcode",
  "NietGeocodeerd",
  "GeenBronrecord",
] as const;

/**
 * The postcode rides along only in the group that is about a postcode, and the VBS number only
 * where VBS holds them: it is the id a beheerder opens the record by.
 */
export function zonderPuntNaam(
  t: TFunction<["paginas", "reistijden"]>,
  reden: (typeof REDENEN)[number],
  rij: {
    naam: string;
    postcode: string | null;
    vbsContactId: number | string | null;
  },
) {
  const nummer = rij.vbsContactId == null ? null : toNumber(rij.vbsContactId);
  const vbsLinkFor = (n: number) => (
    <a
      href={vbsContactUrl(n)}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-0.5 underline-offset-4 hover:underline"
    />
  );
  const vbsIcon = <ExternalLink aria-hidden className="size-3" />;

  if (reden === "NietGeocodeerd" && rij.postcode) {
    return nummer == null ? (
      t("paginas:reistijdenOndersteuners.zonderPunt.naamMetPostcode", {
        naam: rij.naam,
        postcode: rij.postcode,
      })
    ) : (
      <Trans
        t={t}
        i18nKey="paginas:reistijdenOndersteuners.zonderPunt.naamMetPostcodeEnVbsNummer"
        values={{ naam: rij.naam, postcode: rij.postcode, nummer }}
        components={{ a: vbsLinkFor(nummer), icon: vbsIcon }}
      />
    );
  }

  return nummer == null ? (
    rij.naam
  ) : (
    <Trans
      t={t}
      i18nKey="paginas:reistijdenOndersteuners.zonderPunt.naamMetVbsNummer"
      values={{ naam: rij.naam, nummer }}
      components={{ a: vbsLinkFor(nummer), icon: vbsIcon }}
    />
  );
}
